module.exports = __webpack_public_path__ + "static/coffee-ab3d234dc206fcf5d5a3bb1a98da478a.svg";